/** Display label for searchable borrower react-select options. */
export function formatBorrowerLabel(borrower) {
  const name =
    borrower?.display_name || borrower?.full_name || borrower?.business_name || "";
  const phone = borrower?.phone || borrower?.phone_number || "";
  if (name && phone) {
    return `${name} · ${phone}`;
  }
  return name || phone || `Borrower #${borrower?.id}`;
}

export function buildBorrowerSelectOptions(borrowers = []) {
  return borrowers
    .map((borrower) => ({
      value: borrower.id,
      label: formatBorrowerLabel(borrower),
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
}

/** Omit borrowers already picked elsewhere (leader, other member rows, etc.). */
export function excludeBorrowersFromSelect(borrowers = [], excludeIds = []) {
  const excluded = new Set((excludeIds || []).filter(Boolean).map(String));
  if (!excluded.size) {
    return borrowers;
  }
  return borrowers.filter((borrower) => !excluded.has(String(borrower.id)));
}
